// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import ButtonActiveIcon from '../../../assets/images/button-active.svg';
import CrossIcon from '../../../assets/images/cross-icon-white.svg';
import { BIFROST_URL } from '../../../configuration';
import CheckBox from '../../../components/CheckBox';

const S = {
  PopMask: styled.div`
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.31);
  `,
  SubmitContainer: styled.div`
    background: #FCFCFC;
    border-radius: 11px;
    margin-top: 11px;
    position: fixed;
    font-size: 26px;
    line-height: 38px;
    color: #353535;
    top: 10%;
    left: 50%;
    transform: translate(-50%,0%);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  `,
  CloseBar: styled.div`
    background: #EF8200;
    border-radius: 11px 11px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 17px 17px 19px;
  `,
  SubmitContent: styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 39px 52px 15px 52px;
    overflow-y: auto;
    max-height: 400px;
  `,
  WarningIcon: styled.img.attrs({ src: ButtonActiveIcon })`
    margin-right: 30px;
    width: 10px;
    margin-top: 5px;
  `,
  SubmitAction: styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0 52px 39px 52px;
  `,
  SubmitButton: styled.button`
    padding: 4px 27px;
    color: #EF8200;
    font-size: 18px;
    cursor: pointer;

    &:hover{
      border-radius: 7px;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
      background: #EF8200;
      color: #EFEFEF;
      cusor: pointer;
    }
  `,
  BifrostLink: styled.a`
    padding: 4px 27px;
    color: #EF8200;
    font-size: 18px;
    cursor: pointer;

    &:hover{
      border-radius: 7px;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
      background: #EF8200;
      color: #EFEFEF;
      cusor: pointer;
    }
  `,
  WarningMessage: styled.p`
    font-size: 18px;
    color: #4F4F4F;
  `,
  CloseIcon: styled.img.attrs({ src: CrossIcon })`
    max-width: 11px;
    cursor: pointer;
  `,
  CheckBoxText: styled.div`
  `,
  Link: styled.a`
    color: #2a87d0
  `,
}

const PopUpInfo = (props: any): JSX.Element => {
  const setClickSubmit = props.setClickSubmit;

  const [dontAskAgainCheck, setDontAskAgainCheck] = useState(false);
  const handleClose = () => {
    setClickSubmit(false);
    localStorage.setItem('homeInfoRemind', dontAskAgainCheck.toString());
  }

  return (
    <S.PopMask>
      <S.SubmitContainer>
        <S.CloseBar><S.CloseIcon onClick={handleClose}/></S.CloseBar>
        <S.SubmitContent>
          <S.WarningIcon/>
          <S.WarningMessage><FormattedMessage id="B060" values={{ br: <br/>, pdfLink: <S.Link target="_blank" href={'https://ecvcorp.sharepoint.com/:b:/s/msteams_edf5f1/Ec6wSoKypWBFqE7vjLqe6s4B4dXQRfjhfoYDK0CyBEXPGQ?e=hwEael'}>Bifrost Manual</S.Link> }}/></S.WarningMessage>
        </S.SubmitContent>
        <S.SubmitAction>
          <CheckBox onChange={() => setDontAskAgainCheck(!dontAskAgainCheck)} value={'check'} checked={dontAskAgainCheck}>
            <S.CheckBoxText>
              <FormattedMessage id="B061" />
            </S.CheckBoxText>
          </CheckBox>
          <div>
            <S.BifrostLink href={BIFROST_URL} target="_blank"><FormattedMessage id="B062" /></S.BifrostLink>
            <S.SubmitButton onClick={handleClose}><FormattedMessage id="D034" /></S.SubmitButton>
          </div>
        </S.SubmitAction>
      </S.SubmitContainer>
    </S.PopMask>
  )
}

export { PopUpInfo as default };
